// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const AccessList = lazy(() => import('../../views/access/list'))

const Access = [
  {
    path: '/access/list',
    element: <AccessList />
  }
]

export default Access
